// prismjs color theme
require('./src/styles/_prism.scss')
